import { render, staticRenderFns } from "./DocumentsGetComponent.vue?vue&type=template&id=177c5fa3"
import script from "./DocumentsGetComponent.vue?vue&type=script&lang=js"
export * from "./DocumentsGetComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports